import '../scss/framework.scss';
import '../scss/application.scss';
//import 'bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js';
import { initCarousels } from './modules/carousels';
import { initHeaderState } from './modules/header-state';
import { initCloseNavOnClick } from './modules/close-nav-on-click';
import { initSearchGuard } from './modules/search-guard';
import { initShareTools } from './modules/share-tools';
import { initMobileMenuState } from './modules/mobile-menu-state';
import { initAnnunciFiltersSelect } from './modules/annunci-filters-select';
import { initInfoStageCategoryAccordion } from './modules/info-stage-category-accordion';
import { initChatbotTrigger } from './modules/chatbot-trigger';
import { initAskAiVisibility } from './modules/ask-ai-visibility';

const boot = () => { 
  initCarousels();
  initHeaderState();
  initCloseNavOnClick();
  initSearchGuard();
  initShareTools();
  initMobileMenuState();
  initAnnunciFiltersSelect();
  initInfoStageCategoryAccordion();
  initChatbotTrigger();
  initAskAiVisibility();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
